import { BaseModel } from "@blue-chip/core";
import Office from "./Office";

export default class TeamsExtraCount extends BaseModel {
  static get belongsTo() {
    return [Office];
  }
}
